(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cibernetica-contact-dialog"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cib-contact-dialog')) {
    customElements.define('cib-contact-dialog', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.dialog = this.querySelector('dialog');
        this.opener = null;
        const openDialog = (opener) => {
          if (!this.dialog || this.dialog.open || typeof this.dialog.showModal !== 'function') return;
          this.opener = opener?.closest('.cib-mobile-menu')?.querySelector('summary') || opener;
          const topic = this.querySelector('#CibContactTopic');
          if (topic && opener) topic.value = opener.dataset.cibContactTopic || topic.dataset.cibContactDefault;
          const page = this.querySelector('[data-cib-contact-page]');
          if (page && opener?.dataset.cibContactPage) page.value = opener.dataset.cibContactPage;
          document.querySelector('.cib-mobile-menu')?.removeAttribute('open');
          this.dialog.showModal();
          document.documentElement.classList.add('cib-contact-is-open');
          (this.querySelector('[data-cib-contact-result]') || this.querySelector('#CibContactName'))?.focus({ preventScroll: true });
        };
        document.addEventListener('click', (event) => {
          const trigger = event.target.closest('[data-cib-contact-open], .cib-product-description a[href^="mailto:contact@ciberneticausa.com?"]');
          if (!trigger || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || typeof this.dialog?.showModal !== 'function') return;
          event.preventDefault();
          openDialog(trigger);
        }, options);
        this.querySelector('[data-cib-contact-close]')?.addEventListener('click', () => this.dialog.close(), options);
        this.dialog?.addEventListener('close', () => {
          document.documentElement.classList.remove('cib-contact-is-open');
          if (this.opener?.isConnected) this.opener.focus({ preventScroll: true });
        }, options);
        if (this.querySelector('[data-cib-contact-result]')) openDialog(null);
      }
      disconnectedCallback() {
        this.controller?.abort();
        if (this.dialog?.open) this.dialog.close();
        document.documentElement.classList.remove('cib-contact-is-open');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cibernetica-preview-dialog"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cib-preview-gallery')) {
    customElements.define('cib-preview-gallery', class extends HTMLElement {
      connectedCallback() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const { signal } = this.abortController;
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        const closeButton = this.querySelector('[data-preview-close]');
        const loading = this.querySelector('[data-preview-loading]');
        const error = this.querySelector('[data-preview-error]');
        this.querySelectorAll('[data-preview-trigger]').forEach((trigger) => {
          trigger.setAttribute('role', 'button');
          trigger.setAttribute('aria-haspopup', 'dialog');
          trigger.setAttribute('aria-controls', this.dialog.id);
          trigger.addEventListener('keydown', (event) => {
            if (event.key === ' ') {
              event.preventDefault();
              trigger.click();
            }
          }, { signal });
          trigger.addEventListener('click', (event) => {
            if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            this.opener = trigger;
            const thumbnail = trigger.querySelector('img');
            const image = thumbnail.cloneNode(false);
            image.removeAttribute('srcset');
            image.removeAttribute('sizes');
            image.removeAttribute('id');
            image.className = 'cib-preview-dialog-image';
            image.loading = 'eager';
            image.alt = thumbnail.alt || trigger.closest('figure').querySelector('figcaption').textContent;
            loading.hidden = false;
            error.hidden = true;
            image.addEventListener('load', () => { loading.hidden = true; }, { once: true, signal });
            image.addEventListener('error', () => {
              loading.hidden = true;
              error.hidden = false;
              image.hidden = true;
            }, { once: true, signal });
            image.src = trigger.href;
            this.querySelector('[data-preview-image]').replaceChildren(image);
            this.querySelector('[data-preview-caption]').textContent = image.alt;
            this.dialog.showModal();
            document.documentElement.classList.add('cib-preview-is-open');
            closeButton.focus({ preventScroll: true });
          }, { signal });
        });
        closeButton.addEventListener('click', () => this.dialog.close(), { signal });
        const isOutside = (event) => {
          const rect = this.dialog.getBoundingClientRect();
          return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
        };
        this.dialog.addEventListener('pointerdown', (event) => { this.startedOutside = isOutside(event); }, { signal });
        this.dialog.addEventListener('click', (event) => {
          if (this.startedOutside && isOutside(event)) this.dialog.close();
          this.startedOutside = false;
        }, { signal });
        this.dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('cib-preview-is-open');
          this.opener?.focus({ preventScroll: true });
        }, { signal });
      }
      disconnectedCallback() {
        if (this.dialog?.open) {
          this.dialog.close();
          document.documentElement.classList.remove('cib-preview-is-open');
        }
        this.abortController?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
